import { BaseContainerModel } from '../base-container.model';
import { bl_wms_picking_list_gendoc_link_RowInterface, bl_wms_picking_list_gendoc_link_RowClass } from '../../dbschema/index';
    
export class WmsPickingListGendocLinkContainer extends BaseContainerModel {
    bl_wms_picking_list_gendoc_link: bl_wms_picking_list_gendoc_link_RowInterface = new bl_wms_picking_list_gendoc_link_RowClass();
}
